import React, { createContext, useContext } from 'react';
import { LinearProgress } from '@mui/material';
import { useUIContext } from './useUIContext';

export const RepliconNavigationContext = createContext<any>(null);
export const useRepliconNavigationContext = (): any =>
  useContext(RepliconNavigationContext) as any;

export const RepliconNavigationProvider: React.FC = ({ children }) => {
  const { loading, data } = useUIContext();
  return loading || !data ? (
    <LinearProgress variant="query" />
  ) : (
    <RepliconNavigationContext.Provider value={data ?? null}>
      {children}
    </RepliconNavigationContext.Provider>
  );
};

export default RepliconNavigationProvider;
